import React from "react";
import { type Operator } from "../../services/StorageService";
import { VerificatorManagement } from "./VerificatorManagement";
import { VerificatorActivity } from "./VerificatorActivity";

interface OperatorActivityPanelProps {
  operators?: Operator[]; // Local fallback data
}

export const OperatorActivityPanel: React.FC<
  OperatorActivityPanelProps
> = () => {
  return (
    <div className="space-y-6">
      {/* Verificator Management Section */}
      <VerificatorManagement />

      {/* Verificator Activity Section */}
      <VerificatorActivity />
    </div>
  );
};
